import avaxImg from 'src/features/landing/icons/avax.png';
import bnbImg from 'src/features/landing/icons/bnb.png';
import polyImg from 'src/features/landing/icons/polygon.png';
import solImg from 'src/features/landing/icons/solana.png';
import aptosImg from './aptos.webp';

export { bnbImg, polyImg, avaxImg, solImg, aptosImg };
